import clsx from 'clsx';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
  variant?: 'info' | 'error' | 'empty';
}

export function StatePanel({
  title,
  description,
  action,
  variant = 'info',
}: Props): JSX.Element {
  return (
    <div className="mx-auto max-w-screen-2xl px-6 py-12">
      <div
        className={clsx(
          'flex flex-col items-center gap-3 rounded-card border bg-surface p-10 text-center',
          variant === 'error' && 'border-danger/40',
          variant === 'empty' && 'border-border',
          variant === 'info' && 'border-border',
        )}
      >
        <h2
          className={clsx(
            'text-base font-semibold',
            variant === 'error' ? 'text-danger' : 'text-foreground',
          )}
        >
          {title}
        </h2>
        {description && (
          <p className="max-w-md text-sm text-muted">{description}</p>
        )}
        {action}
      </div>
    </div>
  );
}
